/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pushtask.vue?vue&type=template&id=5093da31&scoped=true"
import script from "./pushtask.vue?vue&type=script&lang=js"
export * from "./pushtask.vue?vue&type=script&lang=js"
import style0 from "./pushtask.vue?vue&type=style&index=0&id=5093da31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5093da31",
  null
  
)

export default component.exports